export default {
  customerGroups: []
}
